var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6667 24.7121H20.5097L20.5097 17.2552C20.5097 15.3034 19.703 13.9709 17.9291 13.9709C16.5723 13.9709 15.8178 14.8701 15.4666 15.7367C15.3349 16.0477 15.3554 16.481 15.3554 16.9143V24.7121H10.2465C10.2465 24.7121 10.3123 11.5029 10.2465 10.3022L15.3554 10.3022L15.3554 12.5637C15.6573 11.5749 17.2898 10.1637 19.8951 10.1637C23.1273 10.1637 25.6667 12.2364 25.6667 16.6997L25.6667 24.7121V24.7121ZM5.07989 8.4998H5.04696C3.40068 8.4998 2.33334 7.39824 2.33334 6.00194C2.33334 4.57847 3.43223 3.5 5.11144 3.5C6.78928 3.5 7.82095 4.57575 7.85388 5.99786C7.85388 7.39416 6.78928 8.4998 5.07989 8.4998V8.4998V8.4998ZM2.92188 10.3022L7.46974 10.3022L7.46974 24.7121L2.92188 24.7121L2.92188 10.3022V10.3022Z",
    fill: "#0077B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b9fd18e29aba8495ab6dde81b08e86ab.svg";
export { ForwardRef as ReactComponent };